import { useEffect, useId, useRef, useState } from 'react';
import { contacts, navigation } from '../config/site';

export function SiteHeader() {
  const [isOpen, setIsOpen] = useState(false);
  const menuId = useId();
  const buttonRef = useRef<HTMLButtonElement>(null);
  const firstLinkRef = useRef<HTMLAnchorElement>(null);

  useEffect(() => {
    if (!isOpen) return undefined;

    firstLinkRef.current?.focus();
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        setIsOpen(false);
        buttonRef.current?.focus();
      }
    };

    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [isOpen]);

  const closeMenu = () => setIsOpen(false);

  return (
    <header className="site-header" data-open={isOpen || undefined}>
      <a className="brand" href="#top" aria-label="ALEXADS — к началу страницы" onClick={closeMenu}>
        <strong>ALEXADS</strong>
        <span>Marketing · Websites · Analytics</span>
      </a>

      <nav className="desktop-nav" aria-label="Основная навигация">
        {navigation.map((item) => (
          <a key={item.href} href={item.href}>{item.label}</a>
        ))}
      </nav>

      <div className="locale-status" aria-label="Текущий язык">
        <strong>RU</strong>
      </div>

      <a className="header-cta action-link" href={contacts.emailHref}>Обсудить проект <span aria-hidden="true">→</span></a>

      <button
        ref={buttonRef}
        className="menu-button"
        type="button"
        aria-expanded={isOpen}
        aria-controls={menuId}
        aria-label={isOpen ? 'Закрыть меню' : 'Открыть меню'}
        onClick={() => setIsOpen((value) => !value)}
      >
        <span aria-hidden="true">{isOpen ? 'Закрыть' : 'Меню'}</span>
      </button>

      <nav id={menuId} className="mobile-nav" aria-label="Мобильная навигация" hidden={!isOpen}>
        {navigation.map((item, index) => (
          <a
            key={item.href}
            ref={index === 0 ? firstLinkRef : undefined}
            href={item.href}
            onClick={closeMenu}
          >
            <span>0{index + 1}</span>{item.label}
          </a>
        ))}
      </nav>
    </header>
  );
}
